export type ApiError = {
    code: LSAPIKnownErrorCode | string,
    message: string;
    metadata: {
        AvailableTransactionAmount: number
        RemainingLimitPeriod: string
        ActivationUrl: string
    }
}

export enum LSAPIKnownErrorCode {
    NOT_FOUND = "NOT_FOUND",
    INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
    INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
    FUNDS_ON_HOLD = "FUNDS_ON_HOLD_ERROR",
    COINBASE_AUTHORIZATION_LIMIT_EXCEEDED = "COINBASE_AUTHORIZATION_LIMIT_EXCEEDED",
    COINBASE_INVALID_2FA = "COINBASE_INVALID_2FA",
    ACTIVE_SWAP_LIMIT_EXCEEDED = "ACTIVE_SWAP_LIMIT_EXCEEDED",
    NETWORK_ACCOUNT_ALREADY_EXISTS = "NETWORK_ACCOUNT_ALREADY_EXISTS",
    BLACKLISTED_ADDRESS = "BLACKLISTED_ADDRESS",
    INVALID_ADDRESS_ERROR = "INVALID_ADDRESS_ERROR",
    UNACTIVATED_ADDRESS_ERROR = "UNACTIVATED_ADDRESS_ERROR",
    NETWORK_CURRENCY_DAILY_LIMIT_REACHED = "NETWORK_CURRENCY_DAILY_LIMIT_REACHED",
    ROUTE_NOT_FOUND_ERROR = "ROUTE_NOT_FOUND_ERROR"
}